import { GetterTree } from 'vuex';
import { RootState, ChallengeState } from '@/store';

export const getters: GetterTree<ChallengeState, RootState> = {
};
